export const HYDRATE_STORE = '[navigation] hydrating store with nav data'

export const hydrateStore = config => {
  return {
    type: HYDRATE_STORE,
    payload: config,
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/navigation/navigation.actions.js